import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IShopReviewsData, IShopReviewsAction } from 'models/shop/shopreviews';
import { IStore } from 'redux/IStore';
import { getReviewsForAllShops, approveShopReview, deleteShopReview } from 'redux/modules/shop/shopreviews';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { ItemCardList } from 'components';
import { IInfiniteScrollProps } from 'models/infinitescroll';
const { connect } = require('react-redux');

interface IProps {
	shopReviewsData?: IShopReviewsData;

	/* func props */
	getReviewsForAllShops?: (isFirstLoad: boolean, reviewed?: boolean) => IShopReviewsAction;
	updateShopReview?: (id: string, action: 'approve' | 'delete') => IShopReviewsAction;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		shopReviewsData: state.shopReviews,
	}),
	(dispatch) => ({
		getReviewsForAllShops: (isFirstLoad: boolean, reviewed?: boolean) =>
			dispatch(getReviewsForAllShops(isFirstLoad, reviewed)),
		updateShopReview: (id: string, action: 'approve' | 'delete') =>
			dispatch(action === 'delete' ? deleteShopReview(id) : approveShopReview(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminShopReviews extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		this.props.getReviewsForAllShops(true, false);
	}

	public render() {
		const { t } = this.props;
		const { items, itemsPage } = this.props.shopReviewsData;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: () => {
				this.props.getReviewsForAllShops(false, false);
			},
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_ADMIN_SHOP_REVIEW_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			useIntersectionObserver: true,
			customFunction: (id: string, action: 'approve' | 'delete') => {
				this.props.updateShopReview(id, action);
			},
		};

		return <ItemCardList {...listProps} />;
	}
}
export { AdminShopReviews };
